const MostrarDetalles = () => {
  let $mostrarMas = document.querySelectorAll(".combo__detalles__button");
  Array.from($mostrarMas).forEach((item) => {
    item.addEventListener("click", (event) => {
      const $comboDetalles = event.target.parentNode;
      if ($comboDetalles.classList.contains("--activo")) {
        $comboDetalles.classList.remove("--activo");
        event.target.setAttribute("data-content", "\ue903");
      } else {
        $comboDetalles.classList.add("--activo");
        event.target.setAttribute("data-content", "\ue906");
      }
    });
  });
};

module.exports = {
  init: () => {
    MostrarDetalles();
  },
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/comboCard.js